if (location.hostname !== "localhost") {
    var nameValidated = false;
	var emailValidated = false;
	var pageEnterFinished = false;
	var pageOneFinished = false;
	var pageTwoFinished = false;
	var pageThreeFinished = false;
	var pageFourFinished = false;
	tagManagerStep = "step1";
	window.dataLayer = window.dataLayer || [];
	dataLayer.push({'event': 'tracking'});

	function validateTagManager(){

		var nameTagValidated = false;
		var emailTagValidated = false;
		var telephoneNumberTagValidated = false;
		var airlineTagValidated = false;
		var lostCommitmentTagValidated = false;
		var reportTagValidated = false;
		var whatHappenedTagValidated = false;

		var nameValue = $('#first_name').val();
		var emailValue = $('#email').val();
		var telephoneNumberValue = $('#mobile_number').val();
		var airlineValue = $('#envolved-company').children("option:selected").val();
		var lostCommitmentValue = $('#lost_commitment').val();
		var reportValue = $('#cf_relato').val();

		if(!nameValue.trim().split(' ').length <= 1){
			nameTagValidated = true;
		}

		if(validateEmail(emailValue)){
			emailTagValidated = true;
		}

		if(telephoneNumberValue.length > 0 && telephoneNumberValue != 'hide'){
			telephoneNumberTagValidated = true;
		}

		if(airlineValue.length > 0 && airlineValue != 'hide'){
			airlineTagValidated = true;
		}

		if(lostCommitmentValue.length > 0 && lostCommitmentValue != 'hide'){
			lostCommitmentTagValidated = true;
		}

		if(reportValue.length > 0 && reportValue != 'hide'){
			reportTagValidated = true;
		}

		$('.page-trouble .liberfly-input__checkbox').each(function(index, value) {
			if($(value).find('.checkbox-input').is(':checked')){
				whatHappenedTagValidated = true;
			}
		});

		//Começa a jogar no tag manager
		if(emailTagValidated && nameTagValidated && telephoneNumberTagValidated && !pageOneFinished){
			tagManagerStep = "step2";
			dataLayer.push({'event': 'tracking'});
			pageOneFinished = true;
		}

		if(whatHappenedTagValidated && !pageTwoFinished && pageOneFinished){
			tagManagerStep = "step3";
			dataLayer.push({'event': 'tracking'});
			pageTwoFinished = true;
		}

		if(airlineTagValidated &&
			lostCommitmentTagValidated &&
			!pageThreeFinished &&
			pageOneFinished &&
			pageTwoFinished){

			tagManagerStep = "step4";
			dataLayer.push({'event': 'tracking'});
			pageThreeFinished = true;
		}

		if(reportTagValidated &&
			!pageFourFinished &&
			pageOneFinished &&
			pageTwoFinished &&
			pageThreeFinished){

			tagManagerStep = "step5";
			dataLayer.push({'event': 'tracking'});
			pageFourFinished = true;
		}
	}
}
